export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-force/src/jiggle.js
// module id = ../../../../d3-force/src/jiggle.js
// module chunks = vendor